import React, { FC } from 'react';

import { IBeneficiaryCard } from '../../interfaces';
import s from './CompanyCard.module.scss';

const Body: FC<Pick<IBeneficiaryCard, 'beneficiary'>> = ({
  beneficiary: { full_name, inn },
}) => {
  return (
    <div className={s.beneficiary__info}>
      <span className={s.beneficiary__title}>{full_name}:</span>
      <span className={s.beneficiary__inn}>{`ИНН ${inn}`}</span>
    </div>
  );
};

export default Body;
